import { WorkloadOptimizationPatchWorkload } from '@cast/types';

import { getRightsizingManagementOption } from 'features/cluster/workload-optimization/_utils';

import { type HpaV2Status } from '../../useHpaV2Status';

export const buildWorkloadConfigPatch = ({
  vpaEnabled,
  hpaEnabled,
  hpaV2Status,
}: {
  vpaEnabled: boolean | undefined;
  hpaEnabled: boolean | undefined;
  hpaV2Status: HpaV2Status;
}): WorkloadOptimizationPatchWorkload => {
  // If it is NOT HPAv2 cluster we don't need to include the HPA config in the patch
  const hpaConfig =
    hpaV2Status === 'available'
      ? {
          hpaConfig: {
            managementOption:
              typeof hpaEnabled === 'boolean'
                ? getRightsizingManagementOption(hpaEnabled)
                : undefined,
          },
        }
      : {};

  return {
    workloadConfig: {
      vpaConfig: {
        managementOption:
          typeof vpaEnabled === 'boolean'
            ? getRightsizingManagementOption(vpaEnabled)
            : undefined,
      },
      ...hpaConfig,
    },
  };
};
